import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/software_management/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
